// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sJll","importantInfo":"styles_importantInfo__28jeF"};